import { render, staticRenderFns } from "./PMChartDeadlinesPage.vue?vue&type=template&id=10e0a673&"
import script from "./PMChartDeadlinesPage.vue?vue&type=script&lang=ts&"
export * from "./PMChartDeadlinesPage.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartDeadlinesPage.vue?vue&type=style&index=0&id=10e0a673&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports